module.exports = __webpack_public_path__ + "img/youtube-backup-bg.21937304.png";